import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { getPrivatePage } from "../private-pages";

// Import eagerly: telemetry mode belongs to the document's initial URL, not the
// URL when this route mounts after client-side navigation.
const initialPrivatePage = getPrivatePage(window.location.pathname);

export const PrivatePageGuard = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  const page = getPrivatePage(pathname);
  // Each policy has its own allowlists; switching private pages also needs reload.
  const matchesDocument = Boolean(page && page === initialPrivatePage);
  useEffect(() => {
    if (!matchesDocument) window.location.reload();
  }, [matchesDocument]);

  // BrowserRouter has already updated the URL, so reload preserves its token fragment.
  return matchesDocument ? children : null;
};
